<template>
  <b-container data-app fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          {{ $t("public.views.Pages.Professional.Organization.Survey.title") }}
          <span v-if="patient !== undefined && patient.name">
            - {{ patient.name }} {{ patient.lastname }} (
            {{ patient.document }} )
          </span>
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button style="right" variant="primary" @click="backContacts">{{
          $t("public.views.Pages.Professional.Organization.Survey.btnBack")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <div>
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line></v-text-field>
            <template slot="label">{{
              $t("public.views.Pages.Professional.Organization.Survey.search")
            }}
            </template>
          </v-card-title>
          <v-data-table :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headersSurveyOrganization" :items="surveys" :search="search" item-key="id">
            <template v-slot:item.template="{ item }">
              <div v-if="item.template">
                {{ item.template.name }}
              </div>
              <div v-else>Error</div>
            </template>
            <template v-slot:item.response="{ item }">
              <div v-for="(option, index) in item.surveys" :key="index">
                <div v-if="option.patient && option.patient.id === patient.id">
                  <div v-if="
                    option.surveyQuestions &&
                    option.surveyQuestions.length !== 0
                  ">
                    <b-badge class="text-uppercase" variant="success">Contestado -
                      {{ option.date | adjustToTimezone("DD/MM/YYYY") }}
                    </b-badge>
                  </div>
                  <b-badge v-else class="text-uppercase" variant="danger">Pendiente
                  </b-badge>
                </div>
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <b-badge v-if="item.status === 'SEND'" class="text-uppercase" variant="success">Enviado - {{
                item.createdAt | adjustToTimezone("DD/MM/YYYY")
              }}
              </b-badge>
              <b-badge v-else class="text-uppercase" variant="danger">Pendiente
              </b-badge>
            </template>
            <template v-slot:item.actions="{ item }">
              <div v-for="(option, index) in item.surveys" :key="index">
                <div v-if="option.patient && option.patient.id === patient.id">
                  <div v-if="
                    option.surveyQuestions &&
                    option.surveyQuestions.length !== 0
                  ">
                    <div class="div-table-data">
                      <button :id="'btnSee' + option.id" class="item" v-on:click="getSurvey(item, option)">
                        <i class="ri-eye-line"></i>
                      </button>
                      <b-popover :target="'btnSee' + option.id" placement="botton" triggers="hover focus">
                        <template #title>Ver envío</template>
                      </b-popover>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </v-data-table>
        </div>
      </template>
    </iq-card>
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import SurveyBuilder from "../../../../components/survey/SurveyBuilderSurvey";
import SurveyEngineBuilder from "../../../../components/survey/SurveyBuilderEngineSurvey";
import QuestionsView from "../../../../components/survey/QuestionsView";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import moment from "moment";

import surveyService from "../../../../services/survey";
import patientService from "../../../../services/patient";
import utilsService from "../../../../services/utils";

export default {
  name: "Survey",
  mounted() {
    xray.index();
    this.getAllByPatientStore(this.$route.query.patient);
    this.getPatient(this.$route.query.patient);

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SURVEY", info: "" });
  },
  computed: {},
  methods: {
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    getSurvey(surveyStore, survey) {
      this.$router.push({
        name: "auth.professional.contact.surveyResponse",
        query: {
          surveyId: survey.id,
          templateUuid: surveyStore.template.uuid,
          surveyStoreId: surveyStore.id,
        },
      });
    },
    getAllByPatientStore(patient) {
      let self = this;

      this.$awn.asyncBlock(
        surveyService.getAllByPatientStore(patient),
        (response) => {
          if (response) {
            self.surveys = response.data.content;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.getAllByPatientStore",
            module: "view-pages-professional-contact-surveyPatient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patient: patient
            })
          });
        },
        " "
      );
    },
    async getPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(id),
        (response) => {
          self.patient = response.data;

          self.walletBalance = response.data.walletBalance;
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "view-pages-professional-contact-surveyPatient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    backContacts() {
      var filter = "";
      var status = "";

      if (this.$route.query.queryFilterBack !== undefined) {
        filter = this.$route.query.queryFilterBack;
      }

      if (this.$route.query.queryStatusBack !== undefined) {
        status = this.$route.query.queryStatusBack;
      }

      this.$router.push({
        name: "auth.professional.contact.contacts",
        query: {
          queryFilter: filter,
          queryStatus: status,
        },
      });
    },
  },
  data() {
    return {
      search: "",
      patient: undefined,
      surveyStore: undefined,
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },

      organizationId: localStorage.getItem("organizationId"),
      professional: localStorage.getItem("userId"),
      surveys: [],
      headersSurveyOrganization: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.professional.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: "Plantilla",
          align: "start",
          value: "template",
        },
        {
          text: "Envio",
          align: "start",
          value: "status",
        },
        {
          text: "Respueta",
          align: "start",
          value: "response",
        },
        {
          text: "",
          align: "start",
          value: "actions",
        },
      ],
      professionals: [],
    };
  },
  components: {
    VueTimepicker,
    DatePicker,
    Multiselect,
    SurveyBuilder,
    SurveyEngineBuilder,
    QuestionsView,
    "vue-dropzone": vue2Dropzone,
  },
};
</script>
